import { render, staticRenderFns } from "./PoItems.vue?vue&type=template&id=39973ae8"
import script from "./PoItems.vue?vue&type=script&lang=js"
export * from "./PoItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports